import React, { Component } from "react";
import "./TorkView.scss";
import * as d3 from "d3";

let assets = {
  frame: require("./assets/dialframe.png"),
  batterycharge: require("./assets/batterycharge.png"),
  batterystroke: require("./assets/batterystroke.png"),
  batterychargestroke: require("./assets/batterychargestroke.png"),
  motortemp: require("./assets/motortemp.png"),
  ecutemp: require("./assets/ecutemp.png"),
  high: require("./assets/high.png"),
  hornactive: require("./assets/hornactive.png"),
  horninactive: require("./assets/horninactive.png"),
  keyactive: require("./assets/keyactive.png"),
  keyinactive: require("./assets/keyinactive.png"),
  killswitch: require("./assets/killswitch.png"),
  rpm: require("./assets/rpm.png"),
  throttleinactive: require("./assets/throttleinactive.png"),
  throttleactive: require("./assets/throttleactive.png"),
  backlight0: require("./assets/backlight0.png"),
  backlight1: require("./assets/backlight1.png"),
  indicator0: require("./assets/indicator0.png"),
  indicator1: require("./assets/indicator1.png"),
  lightbeam: require("./assets/headlight.png"),
};

let statKeys = [
  "indicatorL",
  "indicatorR",
  "tailLamp",
  "batteryPercent",
  "ignitionstatus",
  "rpm",
  "torque",
  "ecutemp",
  "motortemp",
  "highBeam",
  "pass",
  "drl",
  "horn",
  "odometer",
  "vol",
  "throttleV",
  "batteryA",
  "speed",
  "throttle",
  "headlight",
  "brakeR",
  "brakeF",
  "killSwitch",
  "torkChargingStatus",
];

class TorkView extends Component {
  state = {
    stats: {},
    simulating: false,
  };
  componentDidMount() {
    this.initDial();
  }
  componentWillUnmount() {
    clearInterval(this.simulate);
  }
  componentDidUpdate(props, state) {
    if (state.stats.rpm != this.state.stats.rpm) {
      this.redrawDial();
    }
  }
  simulateDial() {
    let simulate = (otherState = {}) => {
      this.setState({
        ...otherState,
        stats: {
          ...this.state.stats,
          indicatorL: Math.round(Math.random() * 1),
          indicatorR: Math.round(Math.random() * 1),
          tailLamp: Math.round(Math.random() * 1),
          batteryPercent: Math.round(Math.random() * 100),
          ignitionstatus: Math.round(Math.random() * 1),
          rpm: Math.round(Math.random() * 8000),
          torque: Math.round(Math.random() * 80),
          ecutemp: Math.round(Math.random() * 60),
          motortemp: Math.round(Math.random() * 140),
          highBeam: Math.round(Math.random() * 1),
          pass: Math.round(Math.random() * 1),
          drl: Math.round(Math.random() * 1),
          horn: Math.round(Math.random() * 1),
          odometer:
            (parseInt(this.state.stats.odometer) || 0) +
            Math.round(Math.random() * 10),
          vol: (Math.random() * 15).toFixed(1),
          throttleV: (Math.random() * 15).toFixed(1),
          batteryA: (Math.random() * 2).toFixed(1),
          speed: Math.round(Math.random() * 120),
          throttle: Math.round(Math.random() * 1),
          headlight: Math.round(Math.random() * 1),
          brakeR: Math.round(Math.random() * 1),
          brakeF: Math.round(Math.random() * 1),
          killSwitch: Math.round(Math.random() * 1),
          torkChargingStatus: Math.round(Math.random() * 1),
        },
      });
    };
    simulate({ simulating: true });
    this.simulate = setInterval(simulate, 2000);
  }
  onSimulate = () => {
    if (this.state.simulating) {
      clearInterval(this.simulate);
      let stats = Object.assign(...statKeys.map((s) => ({ [s]: 0 })));
      this.setState({
        simulating: false,
        stats: { ...this.state.stats, ...stats },
      });
    } else {
      this.simulateDial();
    }
  };
  redrawDial = () => {
    let twoPi = Math.PI * 2;
    let startAngle = 0.65;
    let maxAngle = 0.7;
    function arcTween(newAngle) {
      return function (d) {
        var interpolate = d3.interpolate(d.endAngle, newAngle);
        return function (t) {
          d.endAngle = interpolate(t);
          return arc(d);
        };
      };
    }
    let arc = d3
      .arc()
      .innerRadius(this.radius - this.border)
      .outerRadius(this.radius)
      .cornerRadius(this.border)
      .startAngle(twoPi * startAngle);

    let progress = (this.state.stats.rpm || 0) / 8000;
    d3.select("#clipx path")
      .transition()
      .duration(1000)
      .attrTween("d", arcTween(twoPi * (maxAngle * progress + startAngle)));
  };
  initDial = () => {
    let width = 150,
      height = 150;
    let margin = { top: 10, right: 10, bottom: 10, left: 10 };
    let radius = (this.radius = width / 2);
    let border = (this.border = 8);

    let svg = d3.select(".tv-fr-dial svg");
    width = width - margin.left - margin.right;
    height = height - margin.top - margin.bottom;
    svg.attr("width", width + margin.left + margin.right);
    svg.attr("height", height + margin.top + margin.bottom);

    let twoPi = Math.PI * 2;
    let endAngle = 1.35;
    let startAngle = 0.65;

    let arc = d3
      .arc()
      .innerRadius(radius - border)
      .outerRadius(radius)
      .cornerRadius(border)
      .startAngle(twoPi * startAngle);

    svg
      .append("defs")
      .append("clipPath")
      .attr("id", "clipx")
      .append("path")
      .datum({ endAngle: twoPi * endAngle })
      .attr("d", arc.endAngle(twoPi * endAngle));

    let g = svg
      .append("g")
      .attr("transform", "translate(" + radius + "," + radius + ")");

    arc.endAngle(twoPi * endAngle);

    g.append("path").attr("fill", "#686868").attr("d", arc);

    g.append("path")
      .attr("fill", "url(#gradx)")
      .attr("d", arc)
      .style("clip-path", "url(#clipx)");

    g.append("path")
      .attr("fill", "#ccc")
      .attr(
        "d",
        arc.innerRadius(radius - border - 3).outerRadius(radius - border - 2)
      );

    let data = [10, 20, 30, 40, 50, 60, 70, 80];
    let axis = d3
      .scaleLinear()
      .range([0, 252])
      .domain(d3.extent(data, (d) => d));
    radius = radius - 22;
    g.append("g")
      .attr("transform", "translate(0,4)")
      .selectAll("text")
      .data(data)
      .enter()
      .append("text")
      .text((d) => d)
      .attr("transform", (d) => {
        let ratio = axis(d);
        let angle = 144 + ratio;
        angle = angle / 360;
        let x = Math.cos(twoPi * angle) * radius;
        let y = Math.sin(twoPi * angle) * radius;
        return "translate(" + x + "," + y + ")";
      });

    g.append("g")
      .attr("transform", "translate(0,0)")
      .selectAll("text")
      .data(data)
      .enter()
      .append("line")
      .each(function (d) {
        let ratio = axis(d);
        let angle = 144 + ratio;
        angle = angle / 360;
        let xCoord = (radius) => Math.cos(twoPi * angle) * radius;
        let yCoord = (radius) => Math.sin(twoPi * angle) * radius;
        d3.select(this)
          .attr("x1", xCoord(radius + 12))
          .attr("x2", xCoord(radius + 8))
          .attr("y1", yCoord(radius + 12))
          .attr("y2", yCoord(radius + 8));
      });
  };
  updateView = () => {
    if (!this.state.simulating) {
      setTimeout(() => {
        let incomingV = this.props.vehicle().stats;
        let stats = { ...this.state.stats, ...incomingV };
        console.log(stats);
        this.setState({ stats }, this.forceUpdate);
      }, 100);
    }
  };
  renderRpmColor() {
    let colors = ["#3dedf0", "#41fca2", "#ec7d4f", "#ff4200"];
    let progress = (this.state.stats.rpm || 0) / 8000;
    return { color: colors[Math.round((colors.length - 1) * progress)] };
  }
  render() {
    return (
      <div className="TorkView">
        <div className="tv-fr-btns">
          <button onClick={this.onSimulate}>
            <i
              className={
                "fa fa-" +
                (this.state.simulating ? "pause" : "play") +
                "-circle"
              }
            ></i>
          </button>
        </div>
        <div className="tv-top-fr">
          <div className="tv-tfl-lt">
            {this.state.stats.headlight == 1 && <img src={assets.lightbeam} />}
          </div>
          <div className="tv-tfb-bk">
            <div
              className={
                "tv-tfb-bkp lft" + (this.state.stats.brakeR ? " actv" : "")
              }
            ></div>
            <div
              className={
                "tv-tfb-bkp rgt" + (this.state.stats.brakeF ? " actv" : "")
              }
            ></div>
          </div>
          <div className="tv-tfr-dia">
            <div className="tv-fr-dial">
              <svg>
                <defs>
                  <linearGradient id="gradx" x1="0%" x2="100%" y1="0" y2="0">
                    <stop offset="0%" stopColor="#3dedf0"></stop>
                    <stop offset="30%" stopColor="#41fca2"></stop>
                    <stop offset="80%" stopColor="#ec7d4f"></stop>
                    <stop offset="100%" stopColor="#ff4200"></stop>
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <div className="tv-tfr-diac">
              <div className="tv-tdc-top">
                <div>{this.state.stats.speed || 0}</div>
                <div>KMPH</div>
              </div>
              <div className="tv-tdc-btm">
                <div className="tv-tdc-btt">
                  <img
                    src={
                      this.state.stats.throttle
                        ? assets.throttleactive
                        : assets.throttleinactive
                    }
                  />
                </div>
                <div className="tv-tdc-btx">
                  {this.state.stats.throttleV || 0}
                  <span>V</span>
                </div>
              </div>
            </div>
            <div className="tv-tfr-diat">
              <div className="tv-tfd-lft">
                <img
                  src={assets.killswitch}
                  style={{
                    filter:
                      "grayscale(" +
                      (this.state.stats.killSwitch ? 0 : 1) +
                      ")",
                  }}
                />
              </div>
              <div className="tv-tfd-mid">
                <div
                  className={
                    (this.state.stats.highBeam || 0) == 1 ? "ltup" : "ltgr"
                  }
                >
                  <img src={assets.high} />
                </div>
                <div className={this.state.stats.drl || 0 ? "ltup" : null}>
                  DRL
                </div>
                <div className={this.state.stats.pass || 0 ? "ltup" : null}>
                  PASS
                </div>
              </div>
            </div>
            <div className="tv-tfr-dial">
              <div className="tv-tfd-lft">
                <div className="tv-tf-t">{this.state.stats.vol || 0}</div>
                <div className="tv-tf-b">VOL</div>
              </div>
              <div
                className={
                  "tv-tfd-mid" +
                  ((this.state.stats.batteryPercent || 0) < 15 ? " bt-lw" : "")
                }
              >
                <div className={"tv-tfm-b"}>
                  <div
                    className="tv-tfm-bb"
                    style={{
                      height: (this.state.stats.batteryPercent || 0) + "%",
                    }}
                  ></div>
                  <img
                    src={
                      (this.state.stats.batteryPercent || 0) < 15
                        ? assets.batterychargestroke
                        : assets.batterystroke
                    }
                  />
                  {this.state.stats.torkChargingStatus == 1 && (
                    <img src={assets.batterycharge} />
                  )}
                </div>
                <div>{this.state.stats.batteryPercent || 0}%</div>
              </div>
              <div className="tv-tfd-rgt">
                <div className="tv-tf-t">{this.state.stats.batteryA || 0}</div>
                <div className="tv-tf-b">AMP</div>
              </div>
            </div>
            <div className="tv-tfr-diar">
              <div className="tv-tdr top g">
                <div className="tv-tf-im">
                  <img src={assets.motortemp} />
                </div>
                <div className="tv-tf-tx">
                  {this.state.stats.motortemp || 0}
                  <span>&deg;C</span>
                </div>
              </div>
              <div className="tv-tdr btm">
                <div className="tv-tf-im">
                  <img src={assets.ecutemp} />
                </div>
                <div className="tv-tf-tx">
                  {this.state.stats.ecutemp || 0}
                  <span>&deg;C</span>
                </div>
              </div>
            </div>
            <div className="tv-tfr-diab">
              <div className="tv-tdb-lft">
                <img src={assets.rpm} />
                <div>
                  <div className="tv-tdb-t">TORQUE</div>
                  <div className="tv-tdb-b">
                    {this.state.stats.torque || 0}
                    <span>NM</span>
                  </div>
                </div>
              </div>
              <div className="tv-tdb-rgt">
                <img src={assets.rpm} />
                <div>
                  <div className="tv-tdb-t">RPM</div>
                  <div className="tv-tdb-b" style={this.renderRpmColor()}>
                    {this.state.stats.rpm || 0}
                  </div>
                </div>
              </div>
              <div className="tv-tdb-lftt">
                <img
                  src={
                    this.state.stats.horn
                      ? assets.hornactive
                      : assets.horninactive
                  }
                />
              </div>
              <div className="tv-tdb-rgtt">
                <img
                  src={
                    this.state.stats.ignitionstatus
                      ? assets.keyactive
                      : assets.keyinactive
                  }
                />
              </div>
            </div>
            <div className="tv-tfr-ind">
              <div
                className={
                  "tv-tfi-bl rgt" + (this.state.stats.tailLamp ? " ltup" : "")
                }
              >
                <img src={assets.backlight0} />
                <img src={assets.backlight1} className="brgt" />
              </div>
              <div
                className={
                  "tv-tfi-bl lft" + (this.state.stats.tailLamp ? " ltup" : "")
                }
              >
                <img src={assets.backlight0} />
                <img src={assets.backlight1} className="brgt" />
              </div>
              <div
                className={
                  "tv-tfi-il rgt" + (this.state.stats.indicatorR ? " ltup" : "")
                }
              >
                <img src={assets.indicator0} />
                <img src={assets.indicator1} className="brgt" />
              </div>
              <div
                className={
                  "tv-tfi-il lft" + (this.state.stats.indicatorL ? " ltup" : "")
                }
              >
                <img src={assets.indicator0} />
                <img src={assets.indicator1} className="brgt" />
              </div>
            </div>
            <div className="tv-tfr-odo">
              <div className="tv-tfr-odl">
                {(() => {
                  let digits = (parseInt(this.state.stats.odometer) || 0)
                    .toString()
                    .padStart(6, "0")
                    .split("");
                  return digits.map((d, i) => <div key={i}> {d}</div>);
                })()}
              </div>
            </div>
          </div>
          <img src={assets.frame} />
        </div>
        <div className="tv-btm-fr">
          <div className="tv-btf-bx">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    );
  }
}

export default TorkView;
